import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=1d05ef6e&scoped=true"
import script from "./CreateEvent.vue?vue&type=script&lang=js"
export * from "./CreateEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=1d05ef6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05ef6e",
  null
  
)

export default component.exports